import { logMessage, hideMessage } from '../reducers/logger';

export function log(message) {
  return logMessage(message);
}

export function hideLoggerMessage(id) {
  return hideMessage(id);
}
